import api from "../../domain/api";
import {
  GET_LEADS,
  ADD_LEAD,
  EDIT_LEAD,
  GET_LEAD,
  RESET_LEAD,
  GET_ALL_LEADS,
  ERROR_LEAD,
} from "../types/lead_type";
import { handleError } from "../../shared/handleError";
import { setAlert } from "./alert";
export const addLead = (formData) => async (dispatch, getState) => {
  try {
    const { data } = await api.post(`/leads`, formData);
    dispatch({
      type: ADD_LEAD,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getLeads =
  ({
    termField = "",
    term = "",
    pageNumber = "",
    start_from = "",
    start_to = "",
  }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESET_LEAD,
      });
      const { data } = await api.get(
        `/leads?searchTerm=${termField}&keyword=${term}&pageNumber=${pageNumber}&start_from=${start_from}&start_to=${start_to}`
      );

      dispatch({
        type: GET_LEADS,
        payload: data,
      });
    } catch (error) {
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getLead = (id) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_LEAD,
    });
    const { data } = await api.get(`/leads/${id}`);

    dispatch({
      type: GET_LEAD,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const editLead = (id, formData) => async (dispatch) => {
  try {
    const { data } = await api.put(`/leads/${id}`, formData);
    dispatch({
      type: EDIT_LEAD,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const deleteLead = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/leads/${id}`);
    dispatch(setAlert("Lead Deleted Successfully", "success"));
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getAllLeads = () => async (dispatch) => {
  try {
    const { data } = await api.get(`/leads/all`);

    dispatch({
      type: GET_ALL_LEADS,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};

export const handleErrorLocal = () => async (dispatch) => {
  dispatch({ type: ERROR_LEAD });
};
                    